import styled from 'styled-components';
import { Editor } from '@tinymce/tinymce-react';
import React, { useState, useEffect } from 'react';

import Button from '../../../../components/Buttons/Button';
import BaseModal from '../../../../components/BaseModal';
import doFetch from '../../../../api/doFetch';

const ModalHeaderWrapper = styled.div`
  display: flex;
  color: #283890;
`;

const Form = styled.form`
  .tox {
    border-radius: 0px;
    border: unset;
    margin-top: 1px;
  }
  .tox-statusbar__branding {
    display: none;
  }
  & p {
    margin: 0;
  }
`;

const SubmitAreaStyled = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 2px;
`;

export default function ({ isOpen, toggleHandler, vin, hmsId, mutate, text }) {
  const [width, setWidth] = useState(0);
  const [value, setValue] = useState(text);

  const handleResize = () => {
    setWidth(window.innerWidth * 0.75);
  };

  const handleSubmitUser = (event) => {
    event.preventDefault();

    doFetch(`/vehicles/dealership/${hmsId}/vehicle/${vin}/comment`, {
      method: 'PUT',
      body: JSON.stringify({ basic: value })
    })
      .then((vehicle) => {
        mutate(vehicle, false);
        toggleHandler();
      })
      .catch((error) => alert(error));
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    setValue(text || '');
  }, [text]);

  return (
    <BaseModal
      width={width}
      isOpen={isOpen}
      toggleHandler={toggleHandler}
      header={<ModalHeaderWrapper>EDIT VEHICLE COMMENT</ModalHeaderWrapper>}
    >
      <Form onSubmit={handleSubmitUser}>
        <Editor
          styled={{ border: 'unset' }}
          tinymceScriptSrc='/tinymce/tinymce.min.js'
          value={value}
          onEditorChange={(value) => setValue(value)}
          init={{
            menubar: false,
            width: '100%',
            height: 400,
            skin_url: '/tinymce/skins/ui/oxide',
            content_css: '/tinymce/skins/content/default/content.css',
            plugins: 'lists link code wordcount',
            toolbar: 'undo redo | bold italic underline | fontsize | bullist numlist | link | code',
            fontsize_formats: '8pt 10pt 12pt 14pt 16pt 18pt 24pt 36pt 48pt',
            wordcount_max_chars: 8000,
            valid_elements: 'p,strong,em,ul,ol,li,a[href|target],span[style],b,i,u,br,div',
            invalid_elements: 'script,iframe,object,embed',
            init_instance_callback: (editor) => {
              setTimeout(function () {
                var wordcountButton = editor
                  .getContainer()
                  .querySelector('button.tox-statusbar__wordcount');
                if (wordcountButton) {
                  wordcountButton.click();
                }
              }, 200);
            }
          }}
        />
        <SubmitAreaStyled>
          <Button type='submit'>Update</Button>
        </SubmitAreaStyled>
      </Form>
    </BaseModal>
  );
}
